(ns app.domain.form.render-link
  (:require [clojure.string :as str]))

(defn sanitize-url [url]
  (if (str/starts-with? url "www")
    (str "https://" url)
    url))

(defn create-dom-node [[_ md-text md-url raw-url normal-word]]
  (cond
    (and md-text md-url)
    [:a {:href md-url :target "_blank"} md-text]

    raw-url
    [:a {:href (sanitize-url raw-url) :target "_blank"} raw-url]

    :else
    (str " " normal-word " ")))

(defn replace-urls-and-mds [text]
  (->> text
       (re-seq #"\[([^\]]+)\]+\(((?:https?://|www\.)[^ ]+)\)|((?:https?://|www\.)[^\s]+)|([^\s]+)")
       (mapv create-dom-node)))

(defn text-with-anchors [text-content]
  (if (str/includes? text-content "http")
    (->> (replace-urls-and-mds text-content)
         (into [:span]))
    text-content))
